import { render } from "./InfluencerPostTab.vue?vue&type=template&id=797703fc"
import script from "./InfluencerPostTab.vue?vue&type=script&lang=js"
export * from "./InfluencerPostTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__